export const resetSelect = payload => ({
  type: 'RESET_SELECT',
  payload,
});

export const enableSelects = () => ({
  type: 'ENABLE_SELECTS',
});
